import { withStyles } from '@material-ui/core';

import ActionButton from './component';
import styles from './styles';

export default withStyles(styles)(ActionButton);
